import axiosInstance from '@/api/axios'

// 实名认证
export function realAuthApi(parameter: any): Promise<any> {
    return axiosInstance({
        url: '/auth/realAuth',
        method: 'post',
        data: parameter,
    })
}

// 使用统一认证对接身份认证实名认证
export function realAuthIdApi(parameter: any): Promise<any> {
    return axiosInstance({
        url: '/auth/realAuthId',
        method: 'post',
        data: parameter,
    })
}

// 实名认证 - 获取结果
export function realAuthResultApi(parameter: any): Promise<any> {
    return axiosInstance({
        url: '/auth/realAuthResult',
        method: 'post',
        data: parameter,
    })
}
